import { createFileRoute } from '@tanstack/react-router';
import {
  CHOICES_PERMISSIONS,
  createPermissionGuard,
  getPermissionSet,
} from '@bmwe/ui';
import { CreateKassenzeichen } from '../../../features/kassenzeichen/createKassenzeichen';

export const Route = createFileRoute('/auswahlfelder/kassenzeichen/neu')({
  component: CreateKassenzeichen,
  beforeLoad: createPermissionGuard(
    getPermissionSet(CHOICES_PERMISSIONS, 'EDIT'),
  ),
});

export const CreateKassenzeichenRoute = Route;
